var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger",on:{"click":function($event){return _vm.clickHandler()}}},[_c('div',{class:['hamburger__inner', {'hamburger__inner--active' : this.navOpen}]},[_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }